import type { PartnerOrderPartLineUi } from "./partner-order-detail-map";

export type MesOrderWorkflowAssignment = {
  id?: number;
  workflowname?: string | null;
  template_name?: string | null;
  order_part_name?: string | null;
  orderPartName?: string | null;
  order_line_id?: string | number | null;
  orderLineId?: string | number | null;
  part_name?: string | null;
};

export function workflowAssignmentLabel(w: MesOrderWorkflowAssignment): string {
  return (w.template_name ?? w.workflowname ?? "").trim() || "—";
}

export function findWorkflowForPlatformPart(
  partName: string,
  orderLineId: number | null | undefined,
  workflows: MesOrderWorkflowAssignment[],
): MesOrderWorkflowAssignment | undefined {
  const name = partName.trim();
  if (orderLineId != null && String(orderLineId).trim() !== "") {
    const byLine = workflows.find(
      (w) =>
        w.order_line_id != null &&
        String(w.order_line_id) === String(orderLineId),
    );
    if (byLine) return byLine;
  }
  if (!name) return undefined;
  return workflows.find((w) => {
    const wName = (w.order_part_name ?? w.orderPartName ?? w.part_name ?? "").trim();
    return wName === name;
  });
}

export function mergePlatformPartWorkflowAssignments(
  partLines: PartnerOrderPartLineUi[],
  workflows: MesOrderWorkflowAssignment[],
): PartnerOrderPartLineUi[] {
  if (!workflows.length) return partLines;

  return partLines.map((line, index) => {
    const assigned = findWorkflowForPlatformPart(line.part, null, workflows);
    const wfLabel = assigned ? workflowAssignmentLabel(assigned) : "";
    if (!wfLabel || wfLabel === "—") return line;
    return {
      ...line,
      key: line.key || `pl-${index}-${line.part}`,
      workflow: wfLabel,
    };
  });
}
